const AVATAR = 'h-[42px] w-[42px] rounded-full object-cover bg-[#CED3D6]';
const ICON = 'h-[42px] w-[42px] rounded-full object-contain';

export const LeadingAvatar: React.FC<{ user: UserInfo }> = ({ user }) => (
  <img src={PhotoManager.getPhotoURL(user, false)} className={AVATAR} alt={user.nick} />
);

export const LeadingIcon: React.FC<{ src: string; background?: string }> = ({ src, background }) => (
  <img src={src} className={ICON} style={background ? { backgroundColor: background } : undefined} alt="" />
);

/** 문장 안에 끼우는 상대 닉네임. 멤버십이면 색과 하트가 붙는다. */
export const Nickname: React.FC<{ user: UserInfo }> = ({ user }) => (
  <span className={user.photoEffect ? 'membership-profile-nick' : 'normal-profile-nick'}>
    <span>{user.nick}</span>
    {!!user.photoEffect && <img className="icon-membership-profile" src="/imgweb/chat/ic_membership_heart.svg" alt="" />}
  </span>
);

interface NotificationItemProps {
  unread: boolean;
  /** 이 목록에서 읽지 않은 첫 항목에만 머리말을 얹는다. */
  showUnreadHeader?: boolean;
  leading: React.ReactNode;
  title?: React.ReactNode;
  content: React.ReactNode;
  createdTime: number;
  bottom?: React.ReactNode;
  trailing?: React.ReactNode;
  onClick?: () => void;
}

/**
 * 알림 카드 한 장. 제목이 있으면 시각을 제목 옆에, 없으면 본문 아래에 둔다.
 */
const NotificationItem: React.FC<NotificationItemProps> = ({
  unread,
  showUnreadHeader,
  leading,
  title,
  content,
  createdTime,
  bottom,
  trailing,
  onClick,
}) => {
  const time = <span className="typography-caption-body text-base-txt-secondary">{displayTime(createdTime)}</span>;

  return (
    <li className={`flex flex-col px-4 pb-3 pt-[10px] ${unread ? 'bg-base-bg-subtle' : ''}`} onClick={onClick}>
      {showUnreadHeader && <div className="typography-headline-sm pb-[10px] text-base-txt-primary">{brsc.unread}</div>}
      <div className="flex w-full flex-row items-start">
        <div className="me-[11px] flex h-[42px] w-[42px] flex-shrink-0 items-center justify-center">{leading}</div>
        <div className="flex min-w-0 flex-1 flex-col justify-center">
          {title && (
            <div className="typography-headline-sm mb-[2px] flex flex-row flex-wrap items-baseline gap-x-2 text-base-txt-primary">
              {title}
              {time}
            </div>
          )}
          <div className="typography-body-sm break-words text-base-txt-secondary">{content}</div>
          {!title && (
            <>
              {time}
              <div className="h-4" />
            </>
          )}
          {bottom}
        </div>
        {trailing && <div className="ms-4 flex h-[42px] w-[42px] flex-shrink-0 items-center justify-center">{trailing}</div>}
      </div>
    </li>
  );
};

export default NotificationItem;
